import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34075aaa")

_pushScopeId("data-v-34075aaa")
const _hoisted_1 = {
  key: 0,
  class: "panel"
}
const _hoisted_2 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    loading: _ctx.loading,
    animated: "",
    count: _ctx.count,
    style: { display: _ctx.direction === 'row' ? 'flex' : undefined }
  }, {
    template: _withId(() => [
      (_ctx.type === 'panel')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_el_skeleton_item, {
              variant: "circle",
              style: {"width":"50px","height":"50px"}
            }),
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_el_skeleton_item, {
                variant: "p",
                style: {"width":"120px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "h1",
                style: {"width":"60px"}
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withId(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 1
  }, 8, ["loading", "count", "style"]))
})